import {onlineStoresViewerScript} from '@wix/wixstores-client-storefront-sdk';

export const viewerScript = onlineStoresViewerScript();
